import { observer } from 'mobx-react';
import React, { type ReactNode } from 'react';
import styled from 'styled-components';

import { ToolbarButton } from 'components/UI/ToolbarButton';
import store from 'stores/RootStore';
import { type PanelViews } from 'types/PanelViews';

const Label = styled.span`
  font-size: 14px;
`;

export interface DrawerToolbarButtonProps {
  disabled?: boolean;
  label: string;
  panelType: PanelViews;
  icon?: ReactNode;
}

function DrawerToolbarButton({
  disabled,
  icon,
  label,
  panelType,
}: DrawerToolbarButtonProps) {
  const store_creative = store.creative;
  if (!store_creative || !store_creative.canEdit) {
    return null;
  }

  const openDrawer = () => {
    store_creative.setPanelOrToggle(panelType);
  };

  const isDrawerOpen = store_creative.displayPanel === panelType;

  return (
    <ToolbarButton
      selected={isDrawerOpen}
      disabled={disabled}
      onClick={openDrawer}
    >
      {icon}
      <Label>{label}</Label>
    </ToolbarButton>
  );
}

export default observer(DrawerToolbarButton);
